import { render, staticRenderFns } from "./GalleryWriteDefaultLayout.vue?vue&type=template&id=0ae44aac&scoped=true&"
import script from "./GalleryWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./GalleryWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae44aac",
  null
  
)

export default component.exports